import style from "../blog.module.css";
import ExpandableText from "../TextoExpandible";
import React, { Suspense, lazy } from "react";
const InstagramEmbed = lazy(() =>
  import("react-social-media-embed").then((module) => ({
    default: module.InstagramEmbed,
  })),
);

const Semana57: React.FC = () => {
  const Notice1 = `Hoy no hablamos solo de bicicletas, hablamos de ciudad.
📊 +120.000 viajes diarios en bici
⚠️ Menos del 40% de ciclorrutas son seguras
🕊️ Hasta 25 ciclistas mueren al año
Esto tiene que cambiar.
Por eso nace “Cali En Bici”, un proyecto construido con la ciudadanía para hacer de la bicicleta un medio prioritario: más seguridad, mejor infraestructura, integración y cultura vial.
📌 Mañana lo radicamos en el Concejo.
👉 Recuperar la ciudad para la gente es posible.
Porque apostarle a la bici es apostarle a la vida. 💚 #elcambioesconvos
  `;

  return (
    <section className={style.Noticia}>
      <div className={style.Instagram}>
        <Suspense
          fallback={<div className="loading-placeholder">Loading...</div>}
        >
          <InstagramEmbed
            url="https://www.instagram.com/p/DXVgKWNjbdW/"
            width={328}
          />
        </Suspense>
      </div>
      <div className={style.Separador}></div>
      <div className={style.NoticeBox}>
        <h1 className={style.Tittle}>Cali En Bici: una apuesta por la vida </h1>
        <h5 className={style.Fecha}>Abril 19 del 2026</h5>
        <ExpandableText text={Notice1} limit={800} />
        <p className={style.reportero}>
          Oficina de Comunicaciones Concejal Rodrigo Salazar, Partido Alianza
          Verde 🌻{" "}
        </p>
      </div>
    </section>
  );
};

export default Semana57;
